import { Typography } from "@material-ui/core";
import React from "react";

function IneligibleRegistration({ ineligibilityReason }) {
  return (
    <div role="main">
      <Typography variant="h2" gutterBottom>
        You're not eligible to continue registration
      </Typography>
      <Typography variant="body1" gutterBottom>
        {ineligibilityReason}
      </Typography>
      <Typography variant="body1">Because of this, we are unable to process your registration at this time.</Typography>
    </div>
  );
}

export function UnderAgeIneligibleRegistration() {
  return IneligibleRegistration({
    ineligibilityReason:
      "You must be at least 18 years of age to register - the provided date of birth indicates you are not yet 18.",
  });
}

export function MinorSiblingIneligibleRegistration() {
  return IneligibleRegistration({
    ineligibilityReason:
      "You indicated that the adult adoptee has a sibling of the same birth parent who is under the age of 18 years, and who was raised in the same family setting as the adult adoptee.",
  });
}
